import { useState } from "react";
import "@/App.css";
import { useGame } from "./game/useGame";
import { Journey } from "./components/game/Journey";
import { GameScreen } from "./components/game/GameScreen";
import { LumacofonoFooter } from "./components/game/LumacofonoFooter";
import { SiteHeader } from "./components/game/SiteHeader";
import { readChallenge } from "./lib/challenge";
import { readBoardCode } from "./lib/leaderboard";

function App() {
  const game = useGame();
  const [challenge] = useState(readChallenge);
  const [boardCode, setBoardCode] = useState(readBoardCode);
  const inJourney = game.phase === "journey";

  const handleReplay = () => {
    game.reset();
    window.scrollTo({ top: 0 });
  };

  return (
    <div className="app-shell">
      <div className="grain" aria-hidden />
      <div className="aura" aria-hidden />
      <SiteHeader />
      {inJourney ? (
        <Journey
          reachedIndex={game.reachedIndex}
          assignments={game.assignments}
          challenge={challenge}
          boardCode={boardCode}
          onBoardCreated={setBoardCode}
          onReplay={handleReplay}
        />
      ) : (
        <GameScreen game={game} challenge={challenge} boardCode={boardCode} />
      )}
      <div className={inJourney ? "" : "pb-28"}>
        <LumacofonoFooter />
      </div>
    </div>
  );
}

export default App;
